import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from '@ids/button';
import { Modal, ModalContent } from '@ids/modal-dialog';

import '../../../stylesheets/home.scss';
import ImgLeaderLineGreen from '../../../assets/images/ic-4px-leader-line-green.svg';
import zoomIcon from '../../../assets/images/IM/Global/ic-zoom.svg';
import { convertToSnakeCase, getImageSrc } from '../Util/CommonUtils';

const RightChecks = (props) => {
  const [zoomProduct, setZoom] = useState(false);
  const [modalData, setModalData] = useState({});

  const showModal = (modal) => {
    setModalData(modal);
    setZoom(true);
  };

  return (
    <div className="right-checks-container">
      <h2 className="text-align-center margin-container-20">{props.heading}</h2>
      <h4 className="text-align-center margin-container-20">{props.subHeading}</h4>
      <div className="container-center-lg margin-container-20">
        <div className="row right-product-wrap margin-main-section margin-main-xs-section">
          {props.popularProducts.map((product, index) => {
            return (
              <div
                key={index}
                className={`col-xs-12 col-md-4 right-product ${
                  product.isMostPopular ? 'isPopular' : ''
                }`}
              >
                <h4>{product.name}</h4>
                <img
                  src={getImageSrc(ImgLeaderLineGreen)}
                  className="line-separator"
                  alt="..."
                  loading="lazy"
                />
                <p>{product.description}</p>
                <div className="right-product-img-wrap">
                  <picture>
                    <source
                      loading="lazy"
                      height={product.modal.ImageHeight ? product.modal.ImageHeight : 'auto'}
                      width={product.modal.ImageWidth ? product.modal.ImageWidth : 'auto'}
                      alt={product.modal.title}
                      srcset={getImageSrc(product.modal?.ImageSrcOptimized)}
                      type="image/webp"
                    />
                    <img
                      className="right-product-img"
                      loading="lazy"
                      height={product.modal.ImageHeight ? product.modal.ImageHeight : 'auto'}
                      width={product.modal.ImageWidth ? product.modal.ImageWidth : 'auto'}
                      alt={product.modal.title}
                      src={getImageSrc(product.modal.image)}
                    />
                  </picture>
                  <a href="#" className="zoom-image" onClick={() => showModal(product.modal)}>
                    <img
                      src={getImageSrc(zoomIcon)}
                      alt={`zoom-${product.name}`}
                      loading="lazy"
                      height="32px"
                      width="32px"
                      data-testid={`zoom-${product.name}`}
                    />
                  </a>
                </div>
                <Link
                  to={product.customizeLink}
                  data-wa-link={`customize-${product.name}`}
                  aria-label={`customize ${product.name}`}
                  className="customize-btn"
                >
                  <Button
                    theme="quickbooks"
                    buttonType="primary"
                    className="col-xs-12 col-sm-5 right-product-btn"
                    data-ui-object="button"
                    data-refer-ui-access-point={`customize | ${convertToSnakeCase(product.name)}`}
                  >
                    Customize
                  </Button>
                </Link>
                <Link
                  to={product.learnMoreLink}
                  data-wa-link={`learn-more-${product.name}`}
                  data-ui-object="link"
                  data-refer-ui-access-point={`learn_more_about | ${convertToSnakeCase(
                    product.name,
                  )}`}
                  aria-label={`learn more about ${product.name}`}
                  className="learn-more-link right-product-link"
                >
                  Learn more
                </Link>
              </div>
            );
          })}
        </div>
      </div>
      <div className="text-align-center margin-container-20">
        <span>
          <Link
            to="/checks"
            data-wa-link="View all checks styles"
            data-ui-object="link"
            data-refer-ui-access-point="view_all_checks_styles"
          >
            View all checks styles
          </Link>
        </span>
      </div>
      {zoomProduct && (
        <Modal
          dismissible
          onClose={() => {
            setZoom(false);
          }}
          open={zoomProduct}
          backdropZIndex={20000}
          size="large"
          className="zoom-modal"
        >
          <ModalContent className="zoom-modal-container" overflow>
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <picture>
                  <source
                    loading="lazy"
                    alt={modalData?.subTitle}
                    srcset={getImageSrc(modalData?.ImageSrcOptimized)}
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    alt={modalData?.subTitle}
                    src={getImageSrc(modalData.image)}
                  />
                </picture>
              </div>
              <div className="col-xs-12 col-sm-4 text-align-left margin-container-20">
                <h3>{modalData.title}</h3>
                <span>
                  <div className="font-wgt-700 margin-container-20">{modalData.subTitle}</div>
                  <div>{modalData.description}</div>
                </span>
              </div>
            </div>
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

RightChecks.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  popularProducts: PropTypes.array,
};

export default RightChecks;
